<template>
  <div class="confirm-order">
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link to="/confirmOrder">订单确认</router-link>
        </div>
        <div class="order-header">
          <div class="order-status">
            <span class="on"><i>1</i>购物车</span>
            <span class="on"><i>2</i>生成意向单</span>
            <!-- <span><i>3</i>支付</span> -->
            <span><i>3</i>完成</span>
          </div>
        </div>

        <div class="order-info" v-if="true">
          <div class="title">确认订单信息</div>
          <div class="line"></div>
          <div style="width: 130px" class="btn" @click="selectAddr">选择/添加地址</div>
          <div class="address-list">
            <ul v-if="selectAddrData">
              <li class="on">
                <div class="top">
                  <span v-if="selectAddrData.defaultTag === 1" class="label">默认</span>
                  <span class="name">{{ selectAddrData.receiverName }}</span>
                  <!-- <span class="edit" @click="clickShow3">编辑</span> -->
                </div>
                <div class="bottom">
                  <span>收货人姓名：<em>{{ selectAddrData.receiverName }}</em></span>
                  <span>联系方式：<em>{{ selectAddrData.receiverPhone }}</em></span>
                  <span>详细地址：<em>{{ selectAddrData.province + selectAddrData.city + selectAddrData.county + selectAddrData.detailAddress }}</em></span>
                </div>
              </li>
            </ul>
          </div>
          <!-- <div class="logistics">
            <em>物流公司</em>：<span>公司默认物流</span>
          </div> -->
        </div>

        <div class="order-info" v-if="false">
          <div class="title">确认订单信息</div>
          <!-- <div class="num">
						<em>客户采购单号：</em>
						<span @click="clickShow"></span>
						<input type="text" value="此号码将被打印在装箱或者发票上">
					</div>
					<div class="name">
						<em>订购人：</em>
						<span @click="clickShow"></span>
						<input type="text" v-model="listData.name">
					</div>
					<div class="delivery-mode">
						<span>配送方式：</span>
						<label><input type="radio" name="mode"><i></i>一起发货</label>
						<label><input type="radio" name="mode"><i></i>分开发货</label>
						<label><input type="radio" name="mode"><i></i>指定时间</label>
					</div>
					<div class="address">
						<em>收货地址：</em>
						<label>
							<input type="checkbox" value="">
							<i></i>
							<em @click="clickShow2">添加本单收货人</em>
						</label>
					</div> -->
          <div class="line"></div>
          <router-link
            class="add-link"
            :to="{ path: '/receivingAddress', query: { choose: true } }"
            >添加新地址
          </router-link>
          <div class="address-list">
            <ul v-if="listData.receiverName">
              <li class="on">
                <div class="top">
                  <span class="label">默认</span>
                  <span class="name">{{ listData.receiverName }}</span>
                  <!-- <span class="edit" @click="clickShow3">编辑</span> -->
                </div>
                <div class="bottom">
                  <span
                    >收货人姓名：<em>{{ listData.receiverName }}</em></span
                  >
                  <span
                    >联系方式：<em>{{ listData.receiverPhone }}</em></span
                  >
                  <!-- <span>部门名称：<em>综合部</em></span>
									<span>公司名称：<em>撒旦发生的发生的发生</em></span> -->
                  <span
                    >详细地址：<em>{{ listData.detailAddress }}</em></span
                  >
                  <span
                    >邮编：<em>{{ listData.county }}</em></span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="logistics">
            <em>物流公司</em>：<span>公司默认物流</span>
          </div>
        </div>
        <div class="shop-info" v-if="amountPro != 0">
          <div class="title">
            需处理商品<span>共{{ amountPro }}件商品</span>
          </div>
          <div class="infos">
            <table ale style="border-collapse: collapse; width: 100%;text-align: center;table-layout: fixed;">
              <thead style="background-color: #f2f8ff; line-height: 40px; font-size: 1.6rem;">
                <tr>
                  <th colspan="1" style="font-weight: 500;text-align: center;">商品名称</th>
                  <th colspan="1" style="font-weight: 500;text-align: center;">型号</th>
                  <th colspan="1" style="font-weight: 500;text-align: center;">数量</th>
                  <th colspan="1" style="font-weight: 500;text-align: center;">加入时间</th>
                </tr>
              </thead>
              <tbody style="font-size: 1.3rem; line-height: 1.8;white-space: pre-wrap;">
                <tr v-for="(item, index) in prodctList" :key="index" style="border: 1px solid #ececec;">
                  <td colspan="1" style="padding: 2.3rem 0;">
                    <span>{{ item.goodsName }}</span>
                  </td>
                  <td colspan="1" style="padding: 2.3rem 0;">
                    <span>{{ item.specName ? item.specName: item.goods.modelNumber }}</span>
                  </td>
                  <td colspan="1" style="padding: 2.3rem 0;">
                    <span>x{{ item.quantity }}</span>
                  </td>
                  <td colspan="1" style="padding: 2.3rem 0;">
                    <span style="white-space: nowrap">{{ item.whenCreated }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <ul v-if="false">
              <li class="th">
                <span></span>
                <span>商品名称</span>
                <span style="margin-left: 3rem">型号</span>
                <!-- <span>单价</span> -->
                <span>数量</span>
                <span>加入时间</span>
                <!-- <span>小计（金额）</span> -->
              </li>

              <li class="tr">
                <template v-for="(item, index) in prodctList">
                  <div class="box">
                    <span>
                      <!-- <img :src="item.goodsCoverUrl" /> -->
                      <!-- <i :style="`background-image:url(${item.goodsCoverUrl})`"></i> -->
                    </span>
                    <span>{{ item.goodsName }}</span>
                    <span>{{ item.specName ? item.specName: item.goods.modelNumber }}</span>
                    <!-- <span>¥{{ item.price }}</span> -->
                    <span>x{{ item.quantity }}</span>
                    <span style="white-space: nowrap">{{
                      item.whenCreated
                    }}</span>
                    <!-- <span>￥{{ item.totalAmt }}</span> -->
                  </div>
                </template>
              </li>
            </ul>
          </div>
        </div>
        <div class="confirm-info" v-if="false">
          <div class="top">
            <div class="title">确认支付信息</div>
            <div class="invoice">发票信息：<span>您没有发票信息</span></div>
            <!-- <div class="method">支付方式：
							<label><input type="radio" checked="checked" name="method"><i></i>在线支付</label>
							<label><input type="radio" name="method"><i></i>银行转帐</label>
						</div> -->
          </div>
          <div class="bottom">
            <div class="box">
              <div class="title">共{{ amountPro }}件商品</div>
              <div class="txt price">
                <em>应付金额:</em><span>￥{{ totalPrice }}</span>
              </div>
              <div class="txt"><em>含运费:</em><span>￥0.00</span></div>
              <div class="txt"><em>运费折扣:</em><span>￥0.00</span></div>
              <div class="txt"><em>优惠券折扣:</em><span>￥0.00</span></div>
              <div class="txt"><em>含税费:</em><span>￥0.00</span></div>
            </div>
          </div>
        </div>
        <div style="width: 130px" class="btn" @click="payMent">生成意向单</div>
      </div>
    </div>
    <div class="show-modal" v-if="show">
      <div class="modal-box">
        <div class="title-box">
          <div class="title-cell">修改客户采购单号</div>
          <div class="close-icon" @click="clickShow"></div>
        </div>
        <div class="edit-bill-to-user-name-modal">
          <div class="edit-field-area">
            <div class="input-label">客户采购单号</div>
            <input
              type="text"
              maxlength="25"
              placeholder="可输入贵司内部订单号"
            />
          </div>
          <div class="button-area">
            <button>确定</button>
            <button @click="clickShow">取消</button>
          </div>
        </div>
      </div>
    </div>
    <div class="show-modal show-modal-2" v-if="show2">
      <div class="modal-box">
        <div class="title-box">
          <div class="title-cell">本单收货人<em>所有信息均为必填*</em></div>
        </div>
        <div class="edit-bill-to-user-name-modal">
          <div class="edit-field-area">
            <div class="input-label">收货人姓名</div>
            <input type="text" maxlength="20" placeholder="请输入收货人姓名" />
          </div>
          <div class="edit-field-area">
            <div class="input-label">部门名称</div>
            <input type="text" maxlength="20" placeholder="请输入部门名称" />
          </div>
          <div class="message">
            启用【本单收货人】后，本次收货人将以此信息为准。
          </div>
          <div class="button-area">
            <button>确定</button>
            <button @click="clickShow2">取消</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 收货地址编辑 弹窗 -->
    <div class="show-modal show-modal-3" v-if="show3">
      <div class="modal-box">
        <div class="title-box">
          <div class="title-cell">
            编辑收货地址<em>*公司注册地址无法修改（可设为默认地址）</em>
          </div>
        </div>
        <div class="edit-bill-to-user-name-modal">
          <div class="input-box">
            <div class="item-table">
              <div class="item-cell required">公司名称</div>
              <input
                value="公司名称"
                maxlength="30"
                class="input"
                disabled="disabled"
              />
            </div>
            <div class="item-table">
              <div class="item-cell required">部门名称</div>
              <input
                value="部门名称"
                maxlength="30"
                class="input"
                disabled="disabled"
              />
            </div>
            <div class="item-table">
              <div class="item-cell required">收货人姓名</div>
              <input
                value="收货人姓名"
                maxlength="30"
                class="input"
                disabled="disabled"
              />
            </div>
            <div class="item-table">
              <div class="item-cell required">联系方式</div>
              <input
                value="联系方式"
                maxlength="30"
                class="input"
                disabled="disabled"
              />
            </div>
            <div class="item-table">
              <div class="item-cell required">详细地址</div>
              <input
                value="详细地址"
                maxlength="30"
                class="input"
                disabled="disabled"
              />
            </div>
          </div>
          <div class="default-ship-to-cell">
            <label
              ><input
                type="checkbox"
                checked="checked"
              />设为默认收货地址</label
            >
          </div>
          <div class="message">
            如需更改收货人，可通过【本单收货人】功能添加。
          </div>
          <div class="button-area">
            <button>确定</button>
            <button @click="clickShow3">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSeeAddress,
  ordersCart,
  addCart,
  getUserAddressInfo
} from '@/common/http.js';
import {
  message
} from '@/common/common.js';
export default {
  name: 'confirmOrder',
  data() {
    return {
      show: false,
      show2: false,
      show3: false,
      listData: {},
      prodctList: [],
      totalPrice: 0,
      amountPro: 0,
      cartIds: [],
      selectAddrData: {}
    }
  },
  computed: {
    addressList() {
      return this.$store.state.addressList
    }
  },
  watch: {
    addressList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          let addrItem = newVal.find((item) => item.select)
          if (addrItem) {
            this.selectAddrData = addrItem
          } else {
            addrItem = newVal.find((item) => item.defaultTag === 1)
            this.selectAddrData = addrItem
          }
        } else {
          this.selectAddrData = {}
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // this.getSee();
    this.getAddrList()
    this.prodctList = JSON.parse(this.$route.query.arr);
    this.prodctList.map(item => {
      this.totalPrice += item.totalAmt;
      this.amountPro += item.quantity;
      this.cartIds.push(item.uid);
    })
  },
  methods: {
    selectAddr() {
      this.$store.commit('SET_ADDR_SHOW', true)
    },
    getAddrList() {
      const that = this
      getUserAddressInfo({ pageSize: 9999 }).then(res => {
        if (res.result) {
          const tableData = res.data.rows.map((item) => {
            return {
              ...item,
              select: false
            }
          })
          that.$store.commit('SET_ADDRESS', tableData)
        } else {
          that.$message.error(res.data.msg ? res.data.msg : '请求失败')
        }
      })
    },
    // 获取地址
    async getSee() {
      let {
        data
      } = await getSeeAddress({
        pageIndex: 1,
        pageSize: 999999
      })
      if (data.rows.length != 0) {
        data.rows.map(item => {
          if (item.defaultTag == 1) {
            this.listData = item;
          }
        })
        if (!this.listData.receiverName) {
          this.listData = data.rows[0];
        }
      }
    },
    // 去结算
    payMent() {
      let that = this;
      if (!that.selectAddrData.id) {
        that.$message.error('请选择收货地址')
        return
      }
      let obj = {
        uids: JSON.stringify(this.cartIds),
        userAddressId: that.selectAddrData.id
      }
      ordersCart(obj, 'post').then(res => {
        if (res.result) {
          message({
            // message: res.msg,
            message: '生成意向单成功',
            type: 'success'
          })
          // that.$router.back();
          that.$router.replace({
            path: '/meOrder',
            name: 'meOrder'
          });
          that.$store.commit('refreshCart', true)
          // if (res.data.id) {
          //   that.$router.replace({
          //     path: '/orderPayment',
          //     name: 'orderPayment',
          //     query: {
          //       obj: encodeURIComponent(JSON.stringify(res.data))
          //     }
          //   });
          // } else {
          //   message({
          //     message: res.msg,
          //     type: 'warning'
          //   })
          // }
        } else {
          message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    clickShow() {
      let $this = this;
      if ($this.show == false) {
        $this.show = true;
      } else {
        $this.show = false;
      }
    },
    clickShow2() {
      let $this = this;
      if ($this.show2 == false) {
        $this.show2 = true;
      } else {
        $this.show2 = false;
      }
    },
    clickShow3() {
      let $this = this;
      if ($this.show3 == false) {
        $this.show3 = true;
      } else {
        $this.show3 = false;
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/payment/confirmOrder.vue